export const classes = {
  icon: 'mr-3 text-base',
  cancel: 'text-grey-6 hover:text-grey-7',
  skip: 'text-grey-6 hover:text-grey-7',
  skipButton: 'mr-3',
  button: 'transition-colors',
};
